const ascites = [


    { 
    label:"Severity:",
    controlType:"radio button",
    options:["Mild", "Moderate","Severe / tense"]
    },

    
    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }

]

export default ascites